import axios from "axios";

export default {
    getSettings: () => axios.get("/api/plugins/get_settings"),
    read: (ctrl) => axios.get("/api/plugins/read", ctrl && { signal: ctrl.signal }),
    read_all: (ctrl) => axios.get("/api/plugins/read_all", ctrl && { signal: ctrl.signal }),
    readLite: (ctrl) => axios.get("/api/plugins/read_lite", ctrl && { signal: ctrl.signal }),
    createGitChangelog: (obj) => axios.post("/api/plugins/create_git_changelog", obj),
    read_deactivated: () => axios.get("/api/plugins/read_deactivated"),
    find: (id) => axios.get(`/api/plugins/find/${id}`),
    get_build_status: () => axios.get("/api/plugins/get_build_status"),
    pull: (obj) => axios.post("/api/plugins/pull", obj),
    fetch: (obj) => axios.post("/api/plugins/fetch", obj),
    activate: (id) => axios.get(`/api/plugins/activate/${id}`),
    deactivate: (id) => axios.get(`/api/plugins/deactivate/${id}`),
    delete: (id) => axios.get(`/api/plugins/delete/${id}`),
    delete_branch: (obj) => axios.post("/api/plugins/delete_branch", obj),
    update_git: (obj) => axios.post("/api/plugins/update_git", obj),
    update_config: (obj) => axios.post("/api/plugins/update_config", obj),
    clone: (obj) => axios.post("/api/plugins/clone", obj),
    create: (obj) => axios.post("/api/plugins/create", obj),
    order: (obj) => axios.post("/api/plugins/order", obj),
};
